<template>
  <v-footer id="dashboard-core-footer" padless>
    <v-row>
      <v-col align="center">
        <footer>
          <p>
            <a
              href="https://www.facebook.com/TouchCloud-%E5%A4%AA%E5%A5%87%E9%9B%B2%E7%AB%AF-101583138263291/"
              target="_blank"
              ><img
                class="logo"
                src="@/assets/facebook.svg"
                style="height: 20px; width: 20px"
              />
              Facebook
            </a>

            <a href="https://www.touchcloud.com.tw/" target="_blank">
              &copy; TOUCH CLOUD
            </a>
          </p>
        </footer>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "DashboardCoreFooter",
};
</script>

<style lang="sass">
#dashboard-core-footer
  a
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
